import { createSelector, createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  pages: null,
  sidebarOpen: false,
  appSettings: null,
  translations: undefined,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload
    },
    setPages: (state, action) => {
      state.pages = action.payload
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload
    },
    setAppSettings: (state, action) => {
      state.appSettings = action.payload
    },
    setTranslations: (state, action) => {
      state.translations = action.payload
    },
  },
})

export const { setUser, setPages, setSidebarOpen, setAppSettings, setTranslations } =
  appSlice.actions

// Selectors
export const getUserDonationTypes = createSelector(
  [(state) => state.app.user.donorDonationTypeDatas],
  (donorDonationTypeDatas) =>
    _.map(donorDonationTypeDatas, (d) => ({
      donationType: d.donationType,
      donationTypeEnum: d.donationTypeEnum,
    })),
)

export default appSlice.reducer
